var Listings = $.extend(false, BaseModule ,{

    api_route : 'listings',
 
    data : {
    	module          : 'listings',
    	page            : 1,
    	limit           : 42,
        details_with    : 'file:products',
        view            : 'grid',
        order_by        : 'id:desc',
        pagination      : true
    },
 
    keydownTimer:null,
 
    before_save:function(){
        var module_name = this.data.module;
        Builder.set_target($('form[name="'+module_name+'_form"]')).commit();
    },

    after_load_entry:function(){
        "use strict";
        var module_name = this.data.module;
        this.save();
        Builder.set_target($('form[name="'+module_name+'_form"]')).setup();
    },
    save_order:function(){
        var module_name = this.data.module;
        var module = this;

        var selection = [];
        $('input[name="listing_id[]"]').each(function(){
            selection.push($(this).val());
        });


        $.ajax({
            url : API + module.api_route + '/order',
            method:'POST',
            data:{ listing_id: selection },
            success:function(data){
                $("#"+module_name+"-dialog-list").modal('hide');

            }});
        return false;
    },
    init:function(){
        var module_name = this.data.module,module = this;
    }
});

$(document).ready(function(){
    "use strict";
    Listings.init();
});
